import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'

import {
  logout,
  getCurrentUser,
  getCurrentOrganization,
} from '../../../../ducks/users'

import SwitchOrg from './SwitchOrg'

import styles from './AccountMenu.module.css'

const MenuLink = function AccountMenuLink({ text, to, onClose }) {
  return (
    <Link className={styles.menuItem} to={to} onClick={onClose}>
      {text}
    </Link>
  )
}

const Menu = function AccountMenuMenu({ onClose }) {
  const dispatch = useDispatch()
  const history = useHistory()

  const user = useSelector(getCurrentUser)
  const currentOrg = useSelector(getCurrentOrganization)

  const role =
    currentOrg &&
    currentOrg.OrganizationUser &&
    currentOrg.OrganizationUser.role

  console.log('CURRENT ORG:', currentOrg)

  const handleLogout = () => {
    dispatch(logout())
    history.push('/login')
  }

  if (!user) {
    return null
  }

  return (
    <>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.menu}>
        <div className={styles.menuItem}>
          <SwitchOrg />
        </div>
        {role === 'admin' && (
          <MenuLink to="/settings" text="Company Settings" onClose={onClose} />
        )}
        <hr />
        <div className={styles.menuItem}>
          <h5>Signed in as</h5>
          <p className={styles.email}>{user.email}</p>
        </div>
        <MenuLink to="/account" text="My Account" onClose={onClose} />
        <a className={styles.menuItem} onClick={handleLogout}>
          Logout
        </a>
      </div>
    </>
  )
}

export default function AccountMenu() {
  const [expanded, setExpanded] = useState(false)

  const toggle = () => {
    setExpanded(!expanded)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.avatar} onClick={toggle} />
      {expanded && <Menu onClose={toggle} />}
    </div>
  )
}
